import { NotificationsLevel } from "../../../../lib/enums";
import api from "../../../../services/api";
import * as notifications from "../../../../notifications/notifications";
import { prepareAnalysisStatusInformation } from "./AnalysisTableUtils";
import {
  getRLCloudSandboxData,
  getTiCloudData,
  getTiCoreData
} from "./rl_analysis_table/utils";

export const errorCallback = (error, fallbackMsg) => {
  if (error.problem === "CANCEL_ERROR") {
    console.log("Request aborted");
    return;
  }
  const { message } = error?.data || {};
  notifications.show({
    level: NotificationsLevel.ERROR,
    message: message || fallbackMsg
  });
};

export const reanalyzeStatus = (hash, signal) =>
  api.prepareReanalyze({ hashValues: [hash], signal }).then(response => {
    const { tc, ti_cloud, dynamic_analysis } = response.data;
    const { rl_dynamic_analysis } = dynamic_analysis || {};
    const core = getTiCoreData(tc);
    const cloud = getTiCloudData(ti_cloud);
    const rlSandbox = getRLCloudSandboxData(rl_dynamic_analysis);
    const analysis = {
      rl_auxiliary_analysis: {},
      cape: {},
      cisco_secure_malware_analytics: {},
      cuckoo: {},
      fireeye: {},
      joe: {},
      vmray_tcbase: {}
    };
    const {
      rl_auxiliary_analysis,
      cape,
      cisco_secure_malware_analytics,
      cuckoo,
      fireeye,
      joe,
      vmray_tcbase
    } = Object.keys(analysis).reduce(
      (acc, key) => ({
        ...acc,
        [key]: {
          ...prepareAnalysisStatusInformation(dynamic_analysis, key)
        }
      }),
      {}
    );
    return {
      core,
      cloud,
      rlSandbox,
      rl_auxiliary_analysis,
      cape,
      cisco_secure_malware_analytics,
      cuckoo,
      fireeye,
      joe,
      vmray_tcbase
    };
  });

export const reanalyze = (tool, qpOptions, cb) => {
  const qp = {
    samples: [],
    tc: false,
    ti_cloud: false,
    rl_auxiliary_analysis: false,
    cape: false,
    cisco_secure_malware_analytics: false,
    cuckoo: false,
    fireeye: false,
    joe: false,
    vmray_tcbase: false,
    dynamic_analysis: []
  };
  api
    .reanalyze({
      ...qp,
      ...qpOptions
    })
    .then(() => {
      notifications.show({
        level: NotificationsLevel.SUCCESS,
        message: `Sample sent for ${tool} analysis.`
      });
      cb();
    })
    .catch(err => {
      errorCallback(
        err,
        `Failed to send sample for ${tool} analysis. Please try again.`
      );
    });
};
